const validateError = {
    general: {
        networkError: 'Network error. Please try again.',
        unknownError: 'Unknown error. Please try again.'
    },
    field: {
        invalidEmail: 'Invalid e-mail address',
        notBlank: 'Required',
        passwordMismatch: 'Passwords do not match',
        emailNotExists: 'E-mail address does not exist',
        max: 'Maximum {{max}} characters allowed',
        min: 'This field must contain at least {{min}} characters',
        minValue: 'Must be at least {{min}}',
        maxValue: 'Must be less than {{max}}',
        invalidDate: 'Valid date is required',
        invalidFutureBirthday: 'Future birthdate not allowed',
        passwordPattern:
            'The password must have a password length of {{min}} characters, including at least one uppercase, lowercase, number and special character.',
        agreeTermsAndPrivacy: 'You must agree to the terms of use',
        loginPattern:
            'Your login can only contain lower-case letters and digits'
    },
    validation: {
        _comment: 'These validation rules coming from network',
        user: {
            unique: {
                login: 'Login name is already in use',
                email: 'E-mail address is already in use'
            },
            emailNotRegistered:
                'No account has been registered to this email address yet. Please contact support@genomate.health to create an account.'
        },
        file: {
            empty: 'Uploading at least one file is mandatory',
            ext: 'Only allowed extensions are: {{extensions}}',
            ownerUploadedFileWithSameName:
                'Uploading files with the same name are not allowed'
        },
        date: {
            pastDate: 'The entered dates must be in the future'
        },
        maynotbeempty: 'Required',
        constraints: { NotNull: 'Required' }
    }
}

export default validateError
